import PropTypes from 'prop-types'

const NotificationMediaPropTypes = {
  type: PropTypes.string.isRequired, // 3 types: 'image', 'video', 'pdf'
  content: PropTypes.shape({
    url: PropTypes.string, // required for 'image' and 'video'
    fileName: PropTypes.string, // required for 'pdf'
    fileSize: PropTypes.string, // required for 'pdf'
  }),
}

export default NotificationMediaPropTypes
